/** Configuration of colors, icons and labels for various issue types */
import { icons } from '../../components/generic/Icon';
import { getIssueTypeLabel } from '../../helpers/issuesV2';
import type { LicensingIssueType, QualityIssueType } from '../../../shared/issuesV2';
import type { AlertColor, BadgeColor, IconClassName, VulnBadgeColor } from '../../components/generic';

export type IssueConfig = {
  title?: string,
  label: string,
  icon?: IconClassName;
  color: BadgeColor | AlertColor | VulnBadgeColor;
};

export const QUALITY_ISSUE_CONFIG: Record<QualityIssueType, IssueConfig> = {
  blacklisted_dependency: {
    label: 'Blocked',
    icon: icons.times,
    color: 'red',
    title: 'Package blocked',
  },
  outdated_dependency: {
    label: 'Outdated',
    icon: icons.clockO,
    color: 'dark-gray',
    title: 'Outdated version',
  },
  risk_abandonware: {
    label: 'Risk',
    color: 'light-purple',
    title: 'Abandonware',
  },
  'risk_empty-package': {
    label: 'Risk',
    color: 'light-purple',
    title: 'Empty package',
  },
  'risk_native-code': {
    label: 'Risk',
    color: 'light-purple',
    title: 'Native code',
  },
  malware: {
    label: 'Malware',
    icon: icons.alien8bit,
    color: 'dark-red',
    title: 'Malicious Dependency Identified',
  },
};

/**
 * TODO: moved this to shared/ or helpers, as it's used outside of just the inbox
 */
export const LICENSING_ISSUE_CONFIG: Record<LicensingIssueType, IssueConfig> = {
  policy_conflict: {
    label: getIssueTypeLabel('policy_conflict') as string,
    icon: icons.times,
    color: 'red',
  },
  policy_flag: {
    label: getIssueTypeLabel('policy_flag') as string,
    icon: icons.flag,
    color: 'yellow',
  },
  unlicensed_dependency: {
    label: getIssueTypeLabel('unlicensed_dependency') as string,
    icon: icons.questionCircle,
    color: 'dark-gray',
  },
  unconcluded_dependency: {
    label: 'Unconcluded',
    color: 'dark-gray',
    title: 'Unconcluded dependency',
    icon: icons.questionCircle,
  },
  multi_license_concluded: {
    label: 'Concluded (Multi)',
    color: 'yellow',
    title: 'Multi License Concluded',
  },
};
